module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2ab79ba84edfbe96e42aeef5611f4d83.png";